import React from "react";
import { Box } from "@mui/material";
import { colors } from "../theme/colors";

export interface CustomCheckboxComponentProps {
  checked: boolean;
  indeterminate?: boolean;
  onChange: () => void;
  size?: "small" | "medium" | "extra-small";
  disabled?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxComponentProps> = ({
  checked,
  indeterminate = false,
  onChange,
  size = "small",
  disabled = false,
}) => {
  const checkboxSize = size === "extra-small" ? 14 : size === "small" ? 14 : 24;
  const svgSize = checkboxSize;
  const strokeWidth =
    size === "extra-small" ? 2.2 : size === "small" ? 2.4 : 2.8;
  const dashHeight = size === "extra-small" ? 2 : size === "small" ? 2.2 : 2.6;
  const dashY = (24 - dashHeight) / 2;
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (disabled) return;
    if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      onChange();
    }
  };

  return (
    <Box
      role="checkbox"
      aria-checked={indeterminate ? "mixed" : checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onChange}
      sx={{
        userSelect: "none",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.6 : 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: checkboxSize,
        height: checkboxSize,
        backgroundColor: checked || indeterminate ? colors.border.focus : "#fff",
        border: `2px solid ${checked || indeterminate ? colors.border.focus : colors.border.medium}`,
        borderRadius: "3px",
        transition: "all 0.2s ease",
        outline: "none",
        "&:focus": {
          outline: "none",
        },
        "&:hover": {
          backgroundColor: checked || indeterminate ? colors.border.focus : "#fff",
        },
      }}
      onKeyDown={handleKeyDown}
    >
      <svg
        width={svgSize}
        height={svgSize}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {indeterminate ? (
          <rect
            x={4}
            y={dashY}
            width={16}
            height={dashHeight}
            rx={1}
            fill="#FFFFFF"
          />
        ) : checked ? (
          <path
            d="M4 10L10 18L20 6"
            stroke="#FFFFFF"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        ) : null}
      </svg>
    </Box>
  );
};

export default CustomCheckbox;
